/**
 *
 */
export default {
	methods: {
		isDir(item) {
			return Array.isArray(item.children)
		},
		isDirEmpty(item) {
			return item.children.length
		},
		selectItem(tag) {
			tag.selected = true;
			if (this.isDir(tag)) this.tagBoxes[tag.id] = tag;
		},
		forceReRender() {
			this.componentKey += 1;
			this.$forceUpdate();
		}
	},
	computed: {
		onlyOne() {
			return (1 == this.data.min && 1 == this.data.max)
		},
	}
};

//EOF//